<template>
    <div class="row m-0">
          <ul id="accordions" class="menu_ul sub_menu" >
              <div class="panel custom-panel"  >
              <li
                class="main-content cursor-pointer pt-24
                 pl-24 d-flex justify-content-between "
                data-toggle="collapse"
                data-parent="#AccountSettings1"
                href="#AccountSettings1"
                id="profile-details"
              >
                <!-- <a> -->
                  <span class="content">{{$t('profile')}}</span>
                  <span class="content pl-11 " >
                    <img src="/static/images/icons/account_settings_arrow.svg" class="downCarret" />
                    <img src="/static/images/icons/account_settings_arrow.svg" class="upCarret" />
                  </span>
                <!-- </a> -->
              </li>
              <div id="AccountSettings1" class="panel-collapse collapse">
                <div class="panel-body">
                  <ul class="sub_menu ">

                      <li @click="settings('profile')" :class="{active_page:active_tab=='profile'}">
                        <span>{{$t('userProfile')}}</span>
                      </li>

                        <li @click="settings('companyProfile')" :class="{active_page:active_tab=='companyProfile'}">
                          <span>{{$t('companyProfile')}}</span>
                        </li>

                  </ul>
                </div>
              </div>
            </div>
            <div class="panel custom-panel "  >
              <li v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId === roleInfo['Super Admin'] || roleId ===roleInfo['RA Admin']"
                class="main-content  cursor-pointer pl-25 d-flex justify-content-between"
                data-toggle="collapse"
                data-parent="#AccountSettings"
                href="#AccountSettings"
              >

                  <span class="content">{{$t('accountSettings')}}</span>
                  <span class="content pl-11" >
                    <img src="/static/images/icons/account_settings_arrow.svg" class="downCarret" />
                    <img src="/static/images/icons/account_settings_arrow.svg" class="upCarret" />
                  </span>

              </li>
              <div id="AccountSettings" class="panel-collapse collapse">
                <div class="panel-body">
                 <ul class="sub_menu">
                  <li
                    v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId === roleInfo['Super Admin'] || roleId ===roleInfo['RA Admin']"
                    @click="settings('team')"
                    :class="{active_page:active_tab=='team'}"
                  >
                    <span>{{$t('team')}}</span>
                  </li>
                  <li v-if="roleId == 1 || roleId == 5 || roleId == 9" @click="settings('services')" :class="{active_page:active_tab=='services'}">
                    <span>{{$t('services')}}</span>
                  </li>
                  <li v-if="roleId == 1 || roleId == 5 || roleId == 9" @click="settings('billing')" :class="{active_page:active_tab=='billing'}">
                    <span>{{$t('billing')}}</span>
                  </li>
                </ul>
                </div>
              </div>
            </div>
                <!-- <li @click="settings('tour')" class="sub_menu pl-25" :class="{active_page:active_tab=='tour'}">

              <span>{{ $t('virtualTour')}}</span>
            </li>

            <li @click="settings('logout')" class="sub_menu  pl-25" :class="{active_page:active_tab=='logout'}">

              <span>{{$t('logout')}}</span>
            </li> -->

          </ul>

        </div>

</template>

<script>
import $ from 'jquery';

export default {
  props: ['activeTab', 'roleId', 'isDashboardCustomizable', 'roleInfo'],
  data() {
    return {
      active_tab: '',
      isREP: JSON.parse(localStorage.getItem('userData')).account_type_id === 2 || JSON.parse(localStorage.getItem('userData')).account_type_id === 4,
      dashboardCustomizable: null,
      // language: '',
    };
  },
  watch: {
    activeTab() {
      this.active_tab = this.activeTab;
    },
    isDashboardCustomizable() {
      this.dashboardCustomizable = this.isDashboardCustomizable;
    },
    async $route() {
      this.loadComponents();
    },
  },
  mounted() {
    this.loadComponents();
  },
  methods: {
    loadComponents() {
      const pageName = this.$route.query ? this.$route.query.page : '';
      if (pageName === 'profile' || pageName === 'companyProfile') {
        $('#AccountSettings1').collapse('show');
        $('#AccountSettings').collapse('hide');
      } else {
        $('#AccountSettings').collapse('show');
        $('#AccountSettings1').collapse('hide');
      }
    },
    settings(data) {
      // this.$emit('menuClicked', data);
      const pageName = this.$route.query ? this.$route.query.page : '';
      if (pageName !== data) {
        this.$router.push(`/layout/account-settings?page=${data}`);
      }
    },
  },

};
</script>
<style scoped>
#profile-details.collapsed {
  padding-bottom: 15px;
}
.arrow-icons {
float:right;
padding-right:16px
}
.custom-panel {
margin: 0px;
background-color: unset;
border: 0px;
box-shadow: none;
-webkit-box-shadow: none;
}
li.main-content[aria-expanded="true"] span img.upCarret {
display: inline-block;
}
li.main-content[aria-expanded="true"] span img.downCarret {
display: none;
}
li.main-content span img.downCarret {
display: inline-block;
/* transform: rotate(180deg); */
width:18px;
height: 18;
}
li.main-content span img.upCarret {
display: none;
transform: rotate(180deg);
width:18px;
height: 18px;
}
.unclick-item {
cursor: default !important;
}
.line {
border-bottom: 1px solid #828282;
margin: 0 56px 0px 16px;
opacity: 0.2;
}
.inmetro_company_profile {
width: 16px;
height: 16px;
}
.pt_account_settings {
font-size: 20px;
font-weight: 600;
line-height: 28px;
padding: 14px 0px 0px 24px;
}
.account_settings {
font-size: 20px;
font-weight: 600;
line-height: 28px;
padding: 14px 20px 10px 24px;
color: #3E3E3E;
}
.active_page {
background-color: #E6E6E6;
/* font-weight: 700 !important; */
border-right: 4px solid #CA0123;
/* padding-left: 0px !important; */
}
.menu-wrapper {
color: #3E3E3E;
font-family: 'Open Sans';
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;
}
.menu_ul {
list-style: none;
padding: 0px;
}
.menu_ul > li {
/* padding: 5px 10px; */
cursor: pointer;
/* min-height: 32px;
color: #333333;
font-size: 16px;
line-height: 22px;
font-weight: 300; */
}
.menu_ul {
color: #333333;
font-size: 16px;
line-height: 22px;
font-weight: 300;
margin-bottom: 0px;
height: calc(100vh - 155px);
}
.sub_menu {
list-style: none;
padding: 0px;
font-weight: 400;
font-size: 14px;
line-height: 19px;
color: #000;
}
.sub_menu > li {
padding: 8px 0px 7px 34px;
cursor: pointer;
/* margin: 2px 0px 2px 0px; */
}
.sub_menu_wrapper {
padding: 5px 0 8px !important;
cursor: unset !important;
}
.menu_icon {
margin: 0px 18px;
vertical-align: top;
width: 24px;
height: 24px;
}
.panel-body {
padding: 7px 0px 8px 0px;
}
.pl-35 {
padding-left: 35px !important;
}
.pl-25 {
padding-left: 25px !important;
}
.pl-11 {
padding-right: 11px !important;
}
.pl-102 {
padding-left: 102px !important;
}
</style>
